import { useForm, useFormState } from 'react-final-form';
import { type SelectData } from '../types';

export const SELECT_ALL_VALUE = 'all';

export const useSelectCheckbox = (data: SelectData[], name: string) => {
  const form = useForm();
  const { values } = useFormState();
  const allSelected = values?.[name]?.length === data?.length;

  const handleManualChange = (event: React.ChangeEvent<{ value: string }>) => {
    const value = event.target.value;
    if (value[value.length - 1] === SELECT_ALL_VALUE) {
      form.change(
        name,
        allSelected
          ? []
          : data.map(({ value }: { value: string }) => {
              return value;
            })
      );
      return;
    }
    form.change(name, value);
  };

  return {
    handleChange: handleManualChange,
    values
  };
};
